import styled from '@emotion/styled'
import Button from '@material-ui/core/Button'
import {COLORS} from '../../constants'

/** Right side of the card top row holding the action buttons. */
export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`

/** MUI button restyled for the card actions (no upper-casing, never wraps). */
export const ActionButton = styled(Button)`
  text-transform: none;
  white-space: nowrap;
`

/**
 * The "KPIs" toggle button. Extends {@link ActionButton} with a visible pressed style so an
 * open panel is obvious at a glance, matching the button's `aria-expanded`.
 *
 * The pressed state is driven by a `data-active` attribute rather than a styled prop: this is a
 * wrapped MUI `Button`, which forwards unknown props straight to the DOM (unlike the repo's
 * host-element styled components), so a custom `active` prop would leak an invalid attribute.
 */
export const KpiButton = styled(ActionButton)`
  color: ${COLORS.brand};
  border-color: ${COLORS.brand};
  background-color: transparent;

  &:hover {
    background-color: ${COLORS.infoBg};
  }

  &[data-active='true'] {
    color: ${COLORS.cardBg};
    background-color: ${COLORS.brand};
  }

  &[data-active='true']:hover {
    background-color: ${COLORS.brand};
  }
`
